import {
  ClassChildEntity,
} from './classChildEntity';
import { ChildId } from './valueObjects/childId';
import { ClassId } from './valueObjects/classId';
import { HealthRecordType } from './valueObjects/healthRecordType';
import { HideChildNotebook } from './valueObjects/hideChildNotebook';
import { HideCondition } from './valueObjects/hideCondition';
import { Name } from './valueObjects/name';
import { ParentId } from './valueObjects/parentId';

import type {
  ClassChildPropsPub,
  ClassChildPropsPvt,
} from './classChildEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { ClassChildJsonPub, ClassChildJsonPvt } from '@/types/domain/class/entities/classChildEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * ClassChildFactory
 */
export class ClassChildFactory extends FactoryPub<
  ClassChildEntity,
  ClassChildPropsPvt,
  ClassChildJsonPvt,
  ClassChildPropsPub,
  ClassChildJsonPub
> {
  comparePub = (
    a: EntityDataPubType<ClassChildJsonPvt, ClassChildJsonPub>,
    b: EntityDataPubType<ClassChildJsonPvt, ClassChildJsonPub>,
  ) => a.data.childId.localeCompare(b.data.childId, 'en');

  create(
    props: ClassChildPropsPvt,
    propsPub: EntityPubNotNullType<ClassChildPropsPub>,
  ): ClassChildEntity {
    return new ClassChildEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<ClassChildJsonPvt, ClassChildJsonPub>,
  ): ClassChildEntity {
    return this.create({
      classId: ClassId.create(props.data.classId),
      className: Name.create(props.data.className),
      childId: ChildId.create(props.data.childId),
      parentId: ParentId.create(props.data.parentId),
      hideChildNotebook: HideChildNotebook.create(props.data.hideChildNotebook || false),
      hideCondition: HideCondition.create(props.data.hideCondition || false),
      childNotebookContents: props.data.childNotebookContents?.map(
        (v) => HealthRecordType.create(v),
      ),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
